import { render } from "./ban-ve-ghe-phu.vue?vue&type=template&id=001f190e&scoped=true"
import script from "./ban-ve-ghe-phu.vue?vue&type=script&lang=js"
export * from "./ban-ve-ghe-phu.vue?vue&type=script&lang=js"

import "./ban-ve-ghe-phu.vue?vue&type=style&index=0&id=001f190e&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001f190e"]])

export default __exports__